<template>
  <div class="results-details">
    <table class="results-details__table">
      <colgroup>
        <col class="column-check">
        <col class="column-code">
        <col class="column-exam">
        <col class="column-status-child">
      </colgroup>
      <thead class="results-details__table-head">
        <tr>
          <th class="column-check">
            <div class="styled-checkbox" />
          </th>
          <th title="Cod. Exame">
            Código
          </th>
          <th title="Exame">
            Exame
          </th>
          <th class="column-status-child">
            Status
          </th>
        </tr>
      </thead>

      <tbody
        v-for="(result, rowIndex) in resultsChild.examResultDateResponseList"
        :key="rowIndex"
        :md-item="result"
        :class="{ '--bold': !result.generatedInternetDate && result.resultDate !== '' }"
      >
        <tr class="apoio-datatable__line">
          <td class="column-check">
            <div class="styled-checkbox details">
              <input
                :id="'chk' + result.idItemExam"
                v-model="selected"
                type="checkbox"
                :disabled="ableToCheck(result)"
                :value="result.idItemExam"
              >
              <label
                class="list-checkbox"
                :for="'chk' + result.idItemExam"
              />
            </div>
          </td>
          <td class="column-idExam">
            <span :title="result.mnemonic">{{ result.mnemonic }}</span>
          </td>
          <td class="column-exam">
            <span :title="result.descriptionExam">{{ result.descriptionExam }}</span>
          </td>
          <td class="column-status-child">
            <span
              v-if="result.status === $strings.statusColorBalls.CANCELED_MATERIAL.state"
              class="column-status-child column-status-child--canceled-material"
              title="Cancelado"
            >
              Cancelado
            </span>
            <span
              v-if="result.status === $strings.statusColorBalls.SUSPENDED.state"
              class="column-status-child column-status-child--suspended"
              title="Suspenso"
            >
              Suspenso
            </span>
            <span
              v-if="result.status === $strings.statusColorBalls.RECOLLECT.state"
              class="column-status-child column-status-child--recollect"
              title="Recoleta"
            >
              Recoleta
            </span>
            <span
              v-if="result.status === $strings.statusColorBalls.REGISTERED.state"
              class="column-status-child column-status-child--registered"
              title="Cadastrado"
            >
              Cadastrado
            </span>
            <span
              v-if="result.status === $strings.statusColorBalls.PENDING_MATERIAL.state"
              class="column-status-child column-status-child--pending-material"
              title="Amostra Pendente"
            >
              Amostra Pendente
            </span>
            <span
              v-if="result.status === $strings.statusColorBalls.RUNNING.state"
              class="column-status-child column-status-child--running"
              title="Em Execução"
            >
              Em Execução
            </span>
            <span
              v-if="
                result.status === $strings.statusColorBalls.READY.state ||
                  result.status === $strings.statusColorBalls.READED.state
              "
              class="column-status-child column-status-child--ready"
              title="Pronto"
            >
              Pronto
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import mixin from './resultMixin'

export default {
  name: 'ResultsPDFDetails',
  mixins: [mixin],
  props: ['resultsChild'],
  methods: {
    ableToCheck(result) {
      if (result.visibleReport === false) {
        return true
      }
      return result.resultDate === ''
    }
  }
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/mixins';

.results-details {
  font-family: 'Exo 2', sans-serif !important;

  th:last-child,
  td:last-child {
    border-right: 16px solid #fff;
  }

  .column-check {
    width: 45px;
    padding: 0 0 0 14px;
    border-left: 16px solid #fff;
  }

  .last-column {
    border-right: 26px solid #fff;
  }

  .column-code {
    width: 100px;
  }

  .column-exam {
    width: 80%;
    text-align: left;
  }

  .column-status-child {
    width: 290px !important;
    text-align: left !important;

    span {
      font-weight: bold;
    }

    &--registered {
      color: #ed6b75;
    }

    &--running {
      color: #f1c40f;
    }

    &--ready {
      color: #3fc9d5;
    }

    &--pending-material {
      color: #87003f;
    }

    &--suspended {
      color: #919191;
    }

    &--canceled-material {
      color: #b50000;
    }

    &--recollect {
      color: #ff0000;
    }
  }

  .sort-icon {
    position: relative;
  }

  .apoio-datatable {
    margin-top: 0;
  }

  .apoio-datatable__line {
    cursor: default;
  }

  .tooltip-size {
    width: 20px;
  }

  .results-details__table-head th {
    font-weight: 900;
  }

  &__table {
    outline: 16px solid #fff;

    tbody {
      &.--bold {
        font-weight: 700;

        span.column-status-child--ready {
          color: #659be0;
        }
      }
    }

    td {
      white-space: normal;
    }

    tr {
      outline: none;
      height: 47px;
    }

    tr:hover {
      outline: none;
    }

    .styled-checkbox.details {
      padding-top: 10px;

      label {
        margin-top: -2px;
        background-color: #ebebeb;
        border: 1px solid #7a7a7a;
      }

      input[type='checkbox'] {
        opacity: 1;
      }

      input[type='checkbox']:disabled {
        label,
        & + label {
          border: 1px solid #b0b0b0 !important;
          background-color: #b0b0b0 !important;
        }

        & + label:after {
          opacity: 0;
        }
      }
    }
  }

  &__table-head {
    th {
      border-bottom: 2px solid #ffffff;
      white-space: normal;
    }
  }

  .icon-link {
    p {
      cursor: pointer;
    }
  }
}
</style>
